import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import { config } from '../../../config';
import { PreviewMode } from '../preview-elements/preview-context';
import { Text, Box, Heading } from 'wix-style-react';
export var ReviewsPreivewWrapper = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(PreviewMode.Consumer, null, function (value) {
        return value.isPreview ? (React.createElement("div", null,
            React.createElement(Box, { direction: "vertical", paddingTop: '54px' },
                React.createElement(Heading, { appearance: 'H2' }, props.t('solution.page.noReviewsYetTitle')),
                React.createElement(Text, null, props.t('solution.page.preview.reviewsEmptyState'))),
            React.createElement("img", { style: { marginTop: '42px' }, src: config.marketplaceStaticsUrl + "assets/images/preview-page/empty-reviews-1x.png" }))) : (React.createElement("div", null, props.children));
    }));
});
//# sourceMappingURL=reviews-wrapper.js.map